import { render, staticRenderFns } from "./EfsMdDiseaseList.vue?vue&type=template&id=6e0481fc&scoped=true&"
import script from "./EfsMdDiseaseList.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdDiseaseList.vue?vue&type=style&index=0&id=6e0481fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0481fc",
  null
  
)

export default component.exports